import '../../scss/Marquee.scss';

import React, { Component } from 'react';
import ReactDOM from 'react-dom';

class Marquee extends Component {
  constructor(props) {
    super();
    this.state = {
      titleInlineStyle: {}
    };
  }

  componentDidMount() {
    let second = this.overflowTitle.scrollWidth / ((6 / 90) * 1000);
    this.setState({
      titleInlineStyle: {
        animation: `marquee-animation ${second}s linear 1s`
      }
    });
    this.element.addEventListener(
      'animationend',
      () => {
        this.setState(
          {
            titleInlineStyle: {
              animation: `none`
            }
          },
          () => {
            // use setTimeout to ensure the previous setState has rendered
            setTimeout(() => {
              this.setState({
                titleInlineStyle: {
                  animation: `marquee-animation ${second}s linear 3s`
                }
              });
            }, 0);
          }
        );
      },
      false
    );
  }

  render() {
    return (
      <h2
        className="marquee"
        style={this.state.titleInlineStyle}
        ref={element => {
          this.element = element;
        }}
      >
        <div>{this.props.name}</div>
        <div
          ref={element => {
            this.overflowTitle = element;
          }}
        >
          {this.props.name}
        </div>
      </h2>
    );
  }
}

export default Marquee;



/** WEBPACK FOOTER **
 ** ./src/component/Marquee.js
 **/